import React, {useContext, useState} from 'react';
import {Modal} from "../../../../../../components/modal/modal.jsx";
import {FaBuilding, FaUser} from "react-icons/fa6";
import {CitizenContext} from "../context/citizen-context.jsx";

const CitizenTypeModal = ({tabSelected, setTabSelected}) => {
    const {setCitizen, setTabs} = useContext(CitizenContext);
    const [open, setOpen] = useState(!tabSelected);

    const handleType = (type) => {
        setTabSelected("general");
        setOpen(false);

        setCitizen(prev => ({...prev, type}));
    }

    const modalTitle = <span className={"text-center m-0! w-full"}>Selecione um tipo de cadastro</span>

    return (
        <Modal open={open} setOpen={setOpen} className={"w-xl"} isCloseClick={false} showCloseButton={false} title={modalTitle}>
            <Modal.Body className={"px-5 py-10 mt-0! flex justify-between items-center gap-5"}>
                <section className={"text-center cursor-pointer hover:text-(--blue-dark) w-[45%] justify-items-center"} onClick={() => handleType("CPF")}>
                    <FaUser size={90}/>
                    <h2 className={"mt-2"}>CPF</h2>
                </section>

                <div className={"border border-gray-400 h-35"}></div>

                <section className={"text-center cursor-pointer hover:text-(--blue-dark) w-[45%] justify-items-center"} onClick={() => handleType("CNPJ")}>
                    <FaBuilding size={90}/>
                    <h2 className={"mt-2"}>CNPJ</h2>
                </section>
            </Modal.Body>
        </Modal>
    );
};

export default CitizenTypeModal;
